import { useQuery } from "@tanstack/react-query";
import { api } from "./api";
import { APP_TITLE, APP_SUBTITLE, type Branding } from "./branding";

/** Fetch admin-configurable branding (public endpoint; works pre-login). */
export function useBranding() {
  const { data } = useQuery({
    queryKey: ["branding"],
    queryFn: () => api.get<Branding>("/api/branding"),
    staleTime: 5 * 60_000,
  });
  return {
    logo: data?.logo ?? null,
    favicon: data?.favicon ?? null,
    title: data?.title ?? APP_TITLE,
    subtitle: data?.subtitle ?? APP_SUBTITLE,
  };
}
